/**
 * Schedule API - Common Types
 *
 * Shared schemas and entity re-exports used across schedule endpoints.
 */

import { z } from 'zod'
import { UserScheduleSchema, MeetingSchema, DayScheduleSchema } from '../../schemas/entities/schedule'

// Re-export entity types
export { UserScheduleSchema, MeetingSchema, DayScheduleSchema }
export type { UserSchedule, Meeting, DaySchedule } from '../../schemas/entities/schedule'

// ============================================================================
// Offering Type
// ============================================================================

export const OfferingTypeSchema = z.object({
  id: z.number(),
  description: z.string()
})

export type OfferingType = z.infer<typeof OfferingTypeSchema>

// ============================================================================
// Teacher Schemas
// ============================================================================

export const MeetingTeacherSchema = z.object({
  id: z.number(),
  name: z.string(),
  formatted_name: z.string(),
  email: z.string(),
  head: z.boolean()
})

export type MeetingTeacher = z.infer<typeof MeetingTeacherSchema>

export const ExtendedTeacherSchema = z.object({
  id: z.number(),
  head: z.boolean(),
  name: z.string(),
  firstname: z.string(),
  lastname: z.string(),
  preferred_name: z.string(),
  formatted_name: z.string(),
  email: z.string(),
  cell_phone: z.string()
})

export type ExtendedTeacher = z.infer<typeof ExtendedTeacherSchema>

// ============================================================================
// Enriched Section (used across all meeting responses)
// ============================================================================

export const EnrichedSectionSchema = z.object({
  id: z.string(),
  platformId: z.string(),
  name: z.string(),
  courseTitle: z.string(),
  identifier: z.string(),
  offeringType: z.string(),
  faculty: z.array(
    z.object({
      id: z.string(),
      platformId: z.string(),
      firstName: z.string(),
      lastName: z.string()
    })
  )
})

export type EnrichedSection = z.infer<typeof EnrichedSectionSchema>
